<div class='tooltip' [innerHTML]='content' @tooltip></div>
